(() => {
  'use strict';

  const root =
    document.querySelector(
      '.pndash--student'
    );

  if (!root) return;


  const links =
    [
      ...root.querySelectorAll(
        '[data-pndash-section-link]'
      )
    ];


  const sections =
    [
      ...root.querySelectorAll(
        '[data-pndash-section]'
      )
    ];


  if (
    !links.length ||
    !sections.length
  ) {
    return;
  }


  function activate(
    id
  ) {

    links.forEach(
      link => {

        link.classList.toggle(
          'is-active',
          link.dataset
            .pndashSectionLink === id
        );

      }
    );

  }


  links.forEach(
    link => {

      link.addEventListener(
        'click',
        () => {

          activate(
            link.dataset
              .pndashSectionLink
          );

        }
      );

    }
  );


  if (
    'IntersectionObserver' in window
  ) {

    const observer =
      new IntersectionObserver(
        entries => {

          const visible =
            entries
              .filter(
                entry =>
                  entry.isIntersecting
              )
              .sort(
                (a,b) =>
                  b.intersectionRatio -
                  a.intersectionRatio
              )[0];


          if (!visible) {
            return;
          }


          activate(
            visible.target.dataset
              .pndashSection
          );

        },
        {
          rootMargin:
            '-20% 0px -60% 0px',

          threshold:
            [
              0,
              .1,
              .25,
              .5
            ]
        }
      );


    sections.forEach(
      section =>
        observer.observe(
          section
        )
    );

  }

})();


/* STUDENT WORKSPACE SWITCHER START */

function initStudentWorkspaceSwitcher() {

  const dashboard =
    document.querySelector(
      '.pndash--student'
    );

  if (!dashboard) {
    return;
  }


  const links =
    Array.from(
      dashboard.querySelectorAll(
        '[data-pndash-section-link]'
      )
    );


  const sections =
    Array.from(
      dashboard.querySelectorAll(
        '[data-pndash-section]'
      )
    );


  if (!links.length || !sections.length) {
    return;
  }


  function showSection(name, updateHash = true) {

    const target =
      sections.find(section =>
        section.dataset.pndashSection === name
      );

    if (!target) {
      return;
    }


    sections.forEach(section => {

      const active =
        section === target;

      section.hidden =
        !active;

      section.classList.toggle(
        'is-active',
        active
      );

    });


    links.forEach(link => {

      const active =
        link.dataset.pndashSectionLink === name;

      link.classList.toggle(
        'is-active',
        active
      );

      if (active) {
        link.setAttribute(
          'aria-current',
          'page'
        );
      }
      else {
        link.removeAttribute(
          'aria-current'
        );
      }

    });


    if (updateHash) {

      history.replaceState(
        null,
        '',
        '#' + name
      );

    }


    const main =
      dashboard.querySelector(
        '.pndash-main'
      );

    if (main) {

      const top =
        main.getBoundingClientRect().top
        + window.scrollY
        - 118;

      window.scrollTo({
        top,
        behavior:'smooth'
      });

    }

  }


  links.forEach(link => {

    link.addEventListener(
      'click',
      event => {

        event.preventDefault();

        showSection(
          link.dataset.pndashSectionLink
        );

      }
    );

  });


  const initial =
    window.location.hash
      .replace('#', '')
      .trim();


  const allowed =
    sections.some(section =>
      section.dataset.pndashSection === initial
    );


  showSection(
    allowed
      ? initial
      : 'overview',
    false
  );

}


if (
  document.readyState === 'loading'
) {

  document.addEventListener(
    'DOMContentLoaded',
    initStudentWorkspaceSwitcher
  );

}
else {

  initStudentWorkspaceSwitcher();

}

/* STUDENT WORKSPACE SWITCHER END */



/* =========================================================
   PN_EVENTS_NAV_DEBUG
========================================================= */

window.addEventListener(
  'DOMContentLoaded',
  () => {

    const eventsLink =
      document.querySelector(
        '[data-pndash-section-link="events"]'
      );


    const eventsSection =
      document.querySelector(
        '[data-pndash-section="events"]'
      );


    console.log(
      '[PeerNest Events Debug] Initial',
      {
        linkExists:
          !!eventsLink,

        sectionExists:
          !!eventsSection,

        sectionHidden:
          eventsSection?.hidden,

        hash:
          window.location.hash
      }
    );


    eventsLink?.addEventListener(
      'click',
      () => {

        setTimeout(
          () => {

            console.log(
              '[PeerNest Events Debug] After click',
              {
                sectionHidden:
                  eventsSection?.hidden,

                hash:
                  window.location.hash,

                activeClass:
                  eventsSection
                    ?.classList
                    .contains(
                      'is-active'
                    )
              }
            );

          },
          250
        );

      }
    );

  },
  {
    once:true
  }
);




/* =========================================================
   PN_STUDENT_SECTION_NAV_FALLBACK_V1
   Reliable sidebar section navigation
========================================================= */

(() => {

  function getDashboard() {

    return document.querySelector(
      '[data-pnauth-dashboard][data-role="student"]'
    );

  }


  function openDashboardSection(
    name,
    updateHash = true
  ) {

    const dashboard =
      getDashboard();


    if (!dashboard) {
      return false;
    }


    const sections =
      Array.from(
        dashboard.querySelectorAll(
          '[data-pndash-section]'
        )
      );


    const links =
      Array.from(
        dashboard.querySelectorAll(
          '[data-pndash-section-link]'
        )
      );


    const target =
      sections.find(
        section =>
          section.dataset.pndashSection ===
          name
      );


    if (!target) {
      return false;
    }


    sections.forEach(
      section => {

        const active =
          section === target;


        section.hidden =
          !active;


        section.classList.toggle(
          'is-active',
          active
        );

      }
    );


    links.forEach(
      link => {

        const active =
          link.dataset.pndashSectionLink ===
          name;


        link.classList.toggle(
          'is-active',
          active
        );


        if (active) {

          link.setAttribute(
            'aria-current',
            'page'
          );

        }
        else {

          link.removeAttribute(
            'aria-current'
          );

        }

      }
    );


    if (updateHash) {

      history.replaceState(
        null,
        '',
        '#' + name
      );

    }


    return true;

  }


  function openFromHash() {

    const name =
      window.location.hash
        .replace(
          '#',
          ''
        )
        .trim();


    if (name) {

      openDashboardSection(
        name,
        false
      );

    }

  }


  function bootSectionFallback() {

    const dashboard =
      getDashboard();


    if (!dashboard) {
      return;
    }


    dashboard.addEventListener(
      'click',
      event => {

        const link =
          event.target.closest(
            '[data-pndash-section-link]'
          );


        if (
          !link ||
          !dashboard.contains(link)
        ) {
          return;
        }


        const name =
          link.dataset
            .pndashSectionLink;


        if (!name) {
          return;
        }


        event.preventDefault();


        openDashboardSection(
          name,
          true
        );

      }
    );


    openFromHash();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      bootSectionFallback,
      {
        once:true
      }
    );

  }
  else {

    bootSectionFallback();

  }


  window.addEventListener(
    'hashchange',
    openFromHash
  );


  window.addEventListener(
    'pageshow',
    openFromHash
  );

})();
